export default __webpack_public_path__ + "static/media/people.0f312f57.svg";